import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, IconButton, Box, Card, Button, ClickAwayListener, Typography, Popover } from '@mui/material';
import { ReactComponent as TimeIcon } from '../../../assets/icons/main/time-icon.svg';
import { ReactComponent as UpwardTimeIcon } from '../../../assets/icons/main/upward-icon.svg';
import { ReactComponent as DownwardTimeIcon } from '../../../assets/icons/main/downward-icon.svg';
import get from 'lodash/get';
import {palette} from '../../../theme/palette';

const Styles = {
  timeInput: {
    width: '248px',
    // '& .MuiOutlinedInput-root': {
    //   color: '#7382A9',
    // },
  },
  timePicker: {
    bodyWrapper: {
      // position: 'absolute',
      // top: '45px',
      // left: 0,
      // zIndex: 999,
      padding: '24px',
      borderRadius: '18px',
    },
    bodyContent: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 },
    timeWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    arrowIcon: { padding: '4px' },
    showTimeBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #D9DFED',
      borderRadius: '8px',
      padding: '10px 16px',
    },
    timeText: {
      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: '#D9DFED',
      },
    },
    amPmWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      ml: '16px',
    },
    amPmButton: {
      width: '100%',
      height: '50%',
      borderRadius: 0,
      padding: '2px 16px 2px 16px',
      fontSize: '16px',
      fontWeight: 400,
      border: '1px solid #D9DFED',
      '&:hover': { border: '1px solid #D9DFED', color: '#fff', backgroundColor: '#5C85FF' },
    },
    textButton: { padding: 0, fontWeight: '400', minWidth: 0 },
  },
};

const getTimeFromValue = (value: string = '') => {

  const currentTime = new Date();
  const currentHour = currentTime.getHours();
  const currentMinute = currentTime.getMinutes();

  if (value.includes(':')) {
    const splitValue = value.split(':');
    const hours = get(splitValue, '[0]', currentHour % 12 === 0 ? 12 : currentHour % 12);

    const slpitValueS = get(splitValue, '[1]', '').split(' ')
    const minutes = get(slpitValueS, '[0]', currentMinute);
    const period = get(slpitValueS, '[1]', currentHour < 12 ? 'AM' : 'PM');

    return {
      hours: Number(hours),
      minutes: Number(minutes),
      period,
    };
  }
  return {
    hours: currentHour % 12 === 0 ? 12 : currentHour % 12,
    minutes: currentMinute,
    period: currentHour < 12 ? 'AM' : 'PM',
  };
}

const TimePickerComponent = ({ value, onSave, disabled, width }: any) => {
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [period, setPeriod] = useState('AM');
  const [isChangingHour, setIsChangingHour] = useState(false);
  const [isChangingMinute, setIsChangingMinute] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);


  useEffect(() => {
    const { hours, minutes, period } = getTimeFromValue(value);
    setHour(hours);
    setMinute(minutes);
    setPeriod(period);
  }, [value]);

  const handleTextFieldClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // setShowTimePicker(true);
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    if (value) {
      const { hours, minutes, period } = getTimeFromValue(value);
      setHour(hours);
      setMinute(minutes);
      setPeriod(period);
      onSave(value);
    }
    setAnchorEl(null);
    // setShowTimePicker(false);
  };

  const handleHourChange = (e: any) => {
    setIsChangingHour(true);
    let newHour = Math.max(0, Math.min(12, parseInt(e.target.value) || 0));
    setHour(newHour);
    setTimeout(() => setIsChangingHour(false), 500);
  };

  const handleMinuteChange = (e: any) => {
    setIsChangingMinute(true);
    let newMinute = Math.max(0, Math.min(59, parseInt(e.target.value) || 0));
    setMinute(newMinute);
    setTimeout(() => setIsChangingMinute(false), 500);
  };

  const handleHourOnClick = (hourChange: boolean) => {
    setIsChangingHour(true);
    setHour(prev => {
      const newHour = hourChange ? (prev === 12 ? 1 : prev + 1) : (prev === 1 ? 12 : prev - 1);
      return newHour;
    });
    setTimeout(() => setIsChangingHour(false), 500);
  };

  const handleMinuteOnClick = (minChange: boolean) => {
    setIsChangingMinute(true);
    setMinute(prev => {
      const newMinute = minChange ? (prev === 59 ? 0 : prev + 1) : (prev === 0 ? 59 : prev - 1);
      return newMinute;
    });
    setTimeout(() => setIsChangingMinute(false), 500);
  };

  const handlePeriodChange = (selectedPeriod: any) => {
    setPeriod(selectedPeriod);
  };

  const timeValue = `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute} ${period}`;

  const handleOkClick = () => {
    onSave(timeValue);
    setAnchorEl(null);
    // setShowTimePicker(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'time-popover' : undefined;

  return (
    <Box sx={{ position: 'relative' }}>
      <TextField
        variant='outlined'
        size='small'
        value={timeValue}
        fullWidth
        disabled={disabled}
        // onClick={handleTextFieldClick}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={handleTextFieldClick} disabled={disabled}>
                <TimeIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{ ...Styles.timeInput, width: width ? width : '100%', pr: 0,
          '& .MuiInputBase-root': {
            pr: '4px',
          },
        }}
      />

      {/* {showTimePicker && ( */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiPopover-paper': {
            borderRadius: '18px'
          }
        }}
        elevation={8}
      >
        <Card sx={{...Styles.timePicker.bodyWrapper,  backgroundColor:`${palette.primary.contrastText} !important`}}>
          <Box sx={Styles.timePicker.bodyContent}>
            {/* Hour Input */}
            <Box sx={{ ...Styles.timePicker.timeWrapper, mr: '12px' }}>
              <IconButton onClick={() => handleHourOnClick(true)} sx={Styles.timePicker.arrowIcon}>
                <UpwardTimeIcon />
              </IconButton>
              <Box>
                <TextField
                  value={hour < 10 ? `0${hour}` : hour}
                  onChange={handleHourChange}
                  inputProps={{
                    min: 1,
                    max: 12,
                    style: { textAlign: 'center', fontWeight: 400, fontSize: '24px', color: '#64759F' },
                  }}
                  sx={{
                    ...Styles.timePicker.timeText,
                    '& .MuiInputBase-root': {
                      width: '60px',
                      padding: '27px 0',
                      backgroundColor: isChangingHour ? '#5C85FF40' : 'white',
                      '&:hover': { backgroundColor: '#5C85FF40' },

                      '& .MuiInputBase-input.MuiOutlinedInput-input': {
                        paddingBlock: '10px !important'
                      }
                    },
                  }}
                />
              </Box>
              <IconButton onClick={() => handleHourOnClick(false)} sx={Styles.timePicker.arrowIcon}>
                <DownwardTimeIcon />
              </IconButton>
            </Box>

            <Box sx={Styles.timePicker.timeWrapper}>
              <Typography align='center'>:</Typography>
            </Box>

            {/* Minute Input */}
            <Box sx={{ ...Styles.timePicker.timeWrapper, ml: '12px' }}>
              <IconButton onClick={() => handleMinuteOnClick(true)} sx={Styles.timePicker.arrowIcon}>
                <UpwardTimeIcon />
              </IconButton>
              <Box>
                <TextField
                  value={minute < 10 ? `0${minute}` : minute}
                  onChange={handleMinuteChange}
                  inputProps={{
                    min: 0,
                    max: 59,
                    style: { textAlign: 'center', fontWeight: 400, fontSize: '24px', color: '#64759F' },
                  }}
                  sx={{
                    ...Styles.timePicker.timeText,
                    '& .MuiInputBase-root': {
                      width: '60px',
                      padding: '27px 0',
                      backgroundColor: isChangingMinute ? '#5C85FF40' : 'white',
                      '&:hover': { backgroundColor: '#5C85FF40' },

                      '& .MuiInputBase-input.MuiOutlinedInput-input': {
                        paddingBlock: '10px !important'
                      }
                    },
                  }}
                />
              </Box>
              <IconButton onClick={() => handleMinuteOnClick(false)} sx={Styles.timePicker.arrowIcon}>
                <DownwardTimeIcon />
              </IconButton>
            </Box>

            {/* AM/PM Selection */}
            <Box sx={Styles.timePicker.amPmWrapper}>
              <Button
                variant={period === 'AM' ? 'contained' : 'outlined'}
                onClick={() => handlePeriodChange('AM')}
                sx={{
                  ...Styles.timePicker.amPmButton,
                  borderTopRightRadius: '8px',
                  borderTopLeftRadius: '8px',
                  color: period === 'AM' ? '#fff' : '#64759f',
                }}
              >
                AM
              </Button>
              <Button
                variant={period === 'PM' ? 'contained' : 'outlined'}
                onClick={() => handlePeriodChange('PM')}
                sx={{
                  ...Styles.timePicker.amPmButton,
                  borderBottomRightRadius: '8px',
                  borderBottomLeftRadius: '8px',
                  color: period === 'PM' ? '#fff' : '#64759f',
                }}
              >
                PM
              </Button>
            </Box>
          </Box>

          <Box display='flex' justifyContent='flex-end' sx={{ pt: 2 }}>
            <Button
              variant='text'
              onClick={handleClose}
              sx={{ ...Styles.timePicker.textButton, color: '#434D67', mr: 3 }}
            >
              Cancel
            </Button>
            <Button variant='text' onClick={handleOkClick} sx={Styles.timePicker.textButton}>
              Ok
            </Button>
          </Box>
        </Card>
      </Popover>
      {/* )} */}
    </Box>
  );
};

export default TimePickerComponent;
